export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./cashback.vue?vue&type=template&id=351b3c69&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bonuses/cashback.vue?vue&type=template&id=351b3c69&scoped=true
// module id = fS52
// module chunks = 0